import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '../components/ui/button';
import { ArrowLeft, RotateCcw } from 'lucide-react';
import MatchingPairs from '../components/slides/activity/MatchingPairs';
import type { Slide } from '../../utils/supabase/client';

export default function DemoMatchingPairs() {
  const navigate = useNavigate();
  const [key, setKey] = useState(0);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  // Demo slide data
  const demoSlide: Slide = {
    id: 'demo-matching-pairs',
    lesson_id: 'demo',
    type: 'matching_pairs',
    slide_order: 0,
    created_at: new Date().toISOString(),
    content: {
      title: 'Match the Pairs',
      instructions: 'Drag items from the left to match with items on the right',
      leftItems: [
        { id: '1', text: 'Photosynthesis', match: 'a' },
        { id: '2', text: 'Mitochondria', match: 'b' },
        { id: '3', text: 'DNA', match: 'c' },
        { id: '4', text: 'Cell Membrane', match: 'd' },
      ],
      rightItems: [
        { id: 'a', text: 'Process of making food', match: '1' },
        { id: 'b', text: 'Powerhouse of the cell', match: '2' },
        { id: 'c', text: 'Genetic material', match: '3' },
        { id: 'd', text: 'Outer boundary of cell', match: '4' },
      ],
    },
  };

  const handleSubmit = (answer: any) => {
    setHasSubmitted(true);
    console.log('Matching pairs submitted:', answer);
  };

  const handleAnswerChange = (_answer: any) => {
    // Matches are tracked internally by the component
  };

  const handleRestart = () => {
    setHasSubmitted(false);
    setKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-background to-cyan-50 dark:from-blue-950/20 dark:via-background dark:to-cyan-950/20">
      {/* Header */}
      <header className="border-b border-border bg-card/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Button variant="ghost" onClick={() => navigate('/demos')}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Demos
            </Button>
            <Button variant="outline" onClick={handleRestart}>
              <RotateCcw className="w-4 h-4 mr-2" />
              Reset
            </Button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Matching Pairs Demo</h1>
          <p className="text-muted-foreground text-sm md:text-base">
            Drag and drop to match terms with their definitions. Great for vocabulary and concept review!
          </p>
        </div>

        <MatchingPairs
          key={key}
          slide={demoSlide}
          onSubmit={handleSubmit}
          onAnswerChange={handleAnswerChange}
          selectedAnswer={null}
          hasSubmitted={hasSubmitted}
        />
      </div>
    </div>
  );
}
